import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestResetTextsDryGet = {
    path: "/reset-texts/dry",
    method: RouteHttpVerb.GET
};
export { locationRestResetTextsDryGet };
